var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('overview-layout',{ref:"overview",attrs:{"tableCfg":_vm.tableCfg,"fixedFilter":_vm.viewFilter},scopedSlots:_vm._u([{key:"ExtraOptions",fn:function(props){return [(props.isEdit)?_c('round-button-menu',{attrs:{"icon":"mdi-cogs"}},[_c('template',{slot:"options"},[_c('v-list',[_c('v-list-item',{on:{"click":function($event){return _vm.duplicateRecord(
                _vm.$store,
                _vm.$router,
                _vm.tableCfg.apiUrl + props.rec.id,
                { desc: props.rec.desc + ' KOPIE' },
                _vm.tableCfg.url
              )}}},[_c('v-list-item-title',[_vm._v("Dupliceer")])],1)],1)],1)],2):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }